// Validation utilities — extracted from MyScripts/Utils.ts

export function hasValue(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function hasStringValue(str: string): boolean {
  return hasValue(str) && str !== '';
}

export function hasNumericValue(str: any): boolean {
  return hasValue(str) && !isNaN(str);
}
